import jwt_decode from 'jwt-decode'
import { tokenState } from '../modules/authtoken'
import { RcFile } from 'antd/lib/upload'
import { message } from 'antd'
import { LocalStorageKeyType } from './public'
import moment from 'moment'
import { EnterpriseInfo } from '../api/CommonApi'
import { SelectStorageKey } from '../global/fetchData'
import { filterApiData } from '../components/SearchFilter/TemplateData'
import { materialTypeEnum, MaterialTypeValue } from '../global/enum/product'
/**
 * 设置本地LocalStorage
 * @param key 唯一索引
 * @param data 数据
 */
export const SetLocalStorage = (key: LocalStorageKeyType, data: any) => {
  localStorage.setItem(key, JSON.stringify(data))
}

/**
 * 获取本地LocalStorage
 * @param key 唯一索引
 * @return: 数据|null
 */
export function GetLocalStorage(key: LocalStorageKeyType) {
  const data = localStorage.getItem(key)
  return data ? JSON.parse(data) : null
}

/**
 * 删除本地LocalStorage
 * @param key 唯一索引
 */
export const DelLocalStorage = (key: LocalStorageKeyType) => {
  localStorage.removeItem(key)
}

/**
 * 检查localStorage是否存在
 * @param key
 * @returns
 */
export const CheckLocalStorage = (key: LocalStorageKeyType) => {
  const item = localStorage.getItem(key)
  if (item !== null) {
    return true
  }
  return false
}

export function getStorageSelFn(key: SelectStorageKey) {
  const list = GetLocalStorage(key) ?? []
  return (page?: string, str?: string) => {
    return filterApiData(list, str, page)
  }
}

/**
 * 下载
 * @param param 路径
 */
export const download = (param: string, name?: string): void => {
  const a = document.createElement('a')
  a.setAttribute('href', param) // href链接
  a.setAttribute('download', name ? name : '') // download属性
  a.target = '_blank' // 360浏览器会覆盖原页面
  a.click() // 自执行点击事件
}

export const downloadFile = (
  url: string,
  fileName: string = 'file.pdf',
): void => {
  fetch(url)
    .then((res) => res.blob()) // 1. 将文件转为 Blob
    .then((blob) => {
      // 2. 创建一个临时的本地 URL (blob:http://...)
      const blobUrl = window.URL.createObjectURL(blob)

      const a = document.createElement('a')
      a.href = blobUrl
      a.download = fileName // 这里设置文件名在同源（blob）下是生效的
      a.style.display = 'none'

      document.body.appendChild(a)
      a.click()

      // 3. 清理：下载后移除元素并释放 URL 对象
      document.body.removeChild(a)
      window.URL.revokeObjectURL(blobUrl)
    })
    .catch((err) => {
      console.error('下载失败，可能是跨域CORS限制导致无法fetch文件:', err)
      // 如果 fetch 失败（例如严重的跨域限制），作为兜底可以用原逻辑打开
      window.open(url, '_blank')
    })
}
// 解析token
export const decodeAuthToken = (str: string) => {
  const data = jwt_decode<tokenState>(str)
  return data
}

// 重置对象数据
export const resetObj = (obj: { [x: string]: any }) => {
  for (const key in obj) {
    obj[key] = ''
  }
  return obj
}

// 指定上传文件格式
export const Accept = (type: 'image' | 'file' | 'custom') => {
  switch (type) {
    case 'image':
      return 'image/*'
    case 'file':
      return '.doc,.docx,.pdf,.xls,.xlsx,image/*'
    case 'custom':
      return '.jpeg,.gif,.jpg,.png'
    default:
      break
  }
}

// 从图片url中截取图片名称
export const getPicName = (val: string) => {
  const lastIndex = val.lastIndexOf('/')
  return val.substring(lastIndex + 1)
}

// 数字 数字+小数点 中英数字
type strType =
  | 'Number'
  | 'NumberDecimal'
  | 'Text'
  | 'other'
  | 'Format'
  | 'TextNumber'
  | 'English'
  | 'FilterSlash'
  | 'brandCnName'
  | 'brandEnName'
  | 'bankAccount'
  | 'trackingNumber'
export const formatStr = (str: string, type?: strType) => {
  // "[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]" 特殊字符
  if (type === 'Number') {
    // 只能输入数字
    // eslint-disable-next-line
    return str.replace(/[^0-9]/g, '')
  } else if (type === 'NumberDecimal') {
    // 只能数字、小数点
    // eslint-disable-next-line
    if (str[0] === '.') {
      return ''
    }
    return str.replace(/[^0-9.]/g, '').replace(/(\.\d*)\./g, '$1')
  } else if (type === 'Text') {
    // 只能输入中文、英文、数字
    // eslint-disable-next-line
    return str.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g, '')
  } else if (type === 'TextNumber') {
    // 只能输入英文、数字
    // eslint-disable-next-line
    return str.replace(/[^\a-\z\A-\Z0-9]/g, '')
  } else if (type === 'English') {
    // 只能输入英文
    // eslint-disable-next-line
    return str.replace(/[^\a-\z\A-\Z]/g, '')
  } else if (type === 'other') {
    // 替换英文'\ 空格
    // eslint-disable-next-line
    return str.replace(/[\"\\\s]/g, '')
  } else if (type === 'Format') {
    // 替换英文'\
    // eslint-disable-next-line
    return str.replace(/[\"\\]/g, '')
  } else if (type === 'FilterSlash') {
    // 替换英文'\ 空格 /
    // eslint-disable-next-line
    return str.replace(/[\"\\\/\s]/g, '')
    // 银行账户 只支持输入数字和-
  } else if (type === 'bankAccount') {
    // eslint-disable-next-line
    return str.replace(/[^0-9\-]/g, '')
    // 电商供应商发货单物流单号 支持输入英文数字，特殊字符只支持输入/ -
  } else if (type === 'trackingNumber') {
    // eslint-disable-next-line
    return str.replace(/[^a-zA-Z0-9\s/-]/g, '')
  }
  // 默认只能输入非空格的
  return str.replace(/\s+/g, '')
}

// 价格类格式化
export const formatterPrice = (val: any, number?: number) => {
  const value = String(val)
  const num = number ? number : 2
  if (!isNaN(Number(value)) && value.trim() !== '') {
    // 如果没有小数部分，补全为 .00
    if (
      !value.includes('.') ||
      value.split('.')[1].length === 1 ||
      value.endsWith('.')
    ) {
      return parseFloat(value).toFixed(num)
    } else if (value.split('.')[1].length >= num) {
      return parseFloat(value).toFixed(num)
    }
  }
}

// 编辑价格时，超出小数位返回当前内容，让用户自行判断
export const formatterEditPrice = (val: any, number?: number) => {
  const value = String(val)
  const num = number ? number : 2
  if (!isNaN(Number(value)) && value.trim() !== '') {
    // 如果没有小数部分，补全为 .00
    if (
      !value.includes('.') ||
      value.split('.')[1].length === 1 ||
      value.endsWith('.')
    ) {
      return parseFloat(value).toFixed(num)
    } else if (value.split('.')[1].length >= num) {
      return value // 超出小数位返回当前内容，让用户自行判断
    }
  }
}
export const checkImageWH = async (
  file: RcFile,
  width: number,
  height: number,
  errormessage: string,
) => {
  return new Promise(function (resolve, reject) {
    const filereader = new FileReader()
    filereader.onload = (e: any) => {
      const src = e.target ? e.target.result : ''
      const image = new Image()
      image.src = src
      image.onload = function () {
        if (image.naturalWidth !== width || image.naturalHeight !== height) {
          message.error(`上传失败:${errormessage}`)
          reject(false)
        } else {
          resolve(true)
        }
      }
      image.onerror = reject
    }
    filereader.readAsDataURL(file)
  })
}

// 物料等级
export const MaterialLevel = [
  { title: '主推', value: '1' },
  { title: '常规', value: '2' },
  { title: '零星', value: '3' },
]

// 部门属性
export const DepartmentAttr = [
  { title: '基本生产部门', value: 'DP01_SYS' },
  { title: '管理部门', value: 'DP02_SYS' },
  { title: '销售部门', value: 'DP03_SYS' },
  { title: '辅助生产部门', value: 'DP04_SYS' },
  { title: '采购部门', value: 'DP05_SYS' },
  { title: '研发部门', value: 'DP06_SYS' },
]

// 计息类型
export const InterestAttr = [
  { title: '代理品牌', value: 'JXLX0001' },
  { title: '自主品牌', value: 'JXLX0002' },
]

export type RoleTypeParam =
  | 'SOURCE_ASSESS_MAN'
  | 'SOURCE_ASSESS_MANAGER'
  | 'SOURCE_PURCHASE_MAN'
  | 'SOURCE_DATA_MAN'
  | 'SOURCE_PRODUCT_ASSISTANT'
  | 'root'

// 角色
export const RoleType = {
  SOURCE_ASSESS_MAN: 'SOURCE_ASSESS_MAN', // 审核员
  SOURCE_ASSESS_MANAGER: 'SOURCE_ASSESS_MANAGER', // 审核经理
  SOURCE_PURCHASE_MAN: 'SOURCE_PURCHASE_MAN', // 采购员
  SOURCE_PRODUCT_ASSISTANT: 'SOURCE_PRODUCT_ASSISTANT', // 商品助理
  SOURCE_DATA_MAN: 'SOURCE_DATA_MAN', // 数据管理员
}
/**
 * 产生随机整数，包含下限值，包括上限值
 * @param {Number} lower 下限
 * @param {Number} upper 上限
 * @return {Number} 返回在下限到上限之间的一个随机整数
 */
function random(lower: number, upper: number) {
  return Math.floor(Math.random() * (upper - lower + 1)) + lower
}
export const StatementText = () => {
  const arr = [
    '没人喜欢学习可这社会只要成绩',
    '不该有的感情要收起来 好好生活好好爱自己',
    '别在最好的年纪，辜负最好的自己',
    '努力一点吧 为了能走更好的路 遇见更优秀的人',
    '望自己成熟稳重善良填满优秀',
    '会有始料不及的运气会有突如其来的惊喜',
    '宇宙山河浪漫，生活点滴温暖，都值得我前进',
    '生活百般滋味 你要笑着面对',
    '努力过得充实 别留给自己难过的机会',
    '乾坤未定你 我皆是黑马',
    '你必须拼尽全力 才有资格说自己运气不好',
    '生活再平凡 也是限量版 别轻看自己',
    '只要你肯去努力 你就是幸运的',
    '你一定要努力与更好的人相遇',
    '一定要优秀 堵住那悠悠众口',
    '少点以为，多点作为',
    '这个世界从来不公平，你只有努力，才能换来那些平等的待遇',
    '心有猛虎 细嗅蔷薇',
    '你要优秀到所有人都不值得你委屈',
    '觉得已经晚了的时候 就是最早的时候',
  ]
  const index = random(0, arr.length - 1)
  return arr[index]
}

/**
 * 获取供应商id
 * @returns
 */
export const getSupplierId = () => {
  return GetLocalStorage('SUPPLIERID')
}

/**
 * 获取当前用户id
 * @returns
 */
export const getUserId = () => {
  return GetLocalStorage('USERID')
}

export const countToStr = (num: number, max = 99999): string => {
  if (num > max) {
    return max + '+'
  } else {
    return num + ''
  }
}

export const isResponseCodeSuccess = (responseCode: number): boolean => {
  if (responseCode === 0) {
    return true
  }
  return false
}
export const isResponseSuccess = (response: any): boolean => {
  const responseCode = response?.code
  return isResponseCodeSuccess(responseCode)
}

interface ItemInfo {
  id: string
  name: string
  code: string
}
type PlatformInfoKey = keyof ItemInfo

/**
 * srm订单模块  下单平台的列表
 */
export const getPlatformList = (): ItemInfo[] =>
  GetLocalStorage('PLATFORM') || []

export const getSupplierName = (): string =>
  GetLocalStorage('SUPPLIER_NAME') || []

// 中文转英文符号
export const convertToFullWidth = (str: string): string => {
  return str.replace(/[A-Za-z0-9!-/:-@[-`{-~]/g, (char) => {
    // 如果是字母或数字，直接将其转换为全角字符
    const code = char.charCodeAt(0)
    // 字符范围是从半角（33-126）到全角（65281-65374）
    return String.fromCharCode(code + 0xfee0)
  })
}

export const getPlatFormItem = (key: PlatformInfoKey, value: string) => {
  return getPlatformList().filter((item: ItemInfo) => {
    return item?.[key] === value
  })
}

/**
 * 根据下单平台的id 获取中文名
 * @param id
 * @returns
 */
export const getPlatformNameByid = (id: string) => {
  const reslist = getPlatFormItem('id', id)
  if (reslist) {
    return reslist[0].name
  }
  return ''
}

/**
 * 根据下单平台的中文名 获取id
 * @param name
 * @returns
 */
export const getPlatformIdbyName = (name: string) => {
  const reslist = getPlatFormItem('name', name)
  if (reslist) {
    return reslist[0]?.id
  }
  return ''
}
/**
 * 从对象列表中获取一个对象，用一个键值对从对象列表中定位对象
 * @param itemList
 * @param key
 * @param value
 * @returns
 */
export const getItemFromItemListByProperty = (
  itemList: any[],
  key: string,
  value: any,
) => {
  for (const item of itemList) {
    if (item[key] === value) {
      return item
    }
  }
  return undefined
}

// 防抖 typescript
export const debounce = (func: () => void, wait: number) => {
  let timer: any = null
  return function () {
    // 如果事件被触发的时候定时器不为空,重新设置定时器,这样就只有第一次的时候会执行,因为初始定时器为空,所以就会设置一个定时器,后续的点击会清空,导致最后请求被延迟执行
    if (timer) {
      clearTimeout(timer)
      timer = null
    }
    timer = setTimeout(func, wait)
  }
}

/**
 * 数字格式化：若超出最大数返回 最大数+ ，否则返回原数
 * @param num 原数
 * @param maxNum 最大数
 * @returns
 */
export const formatNum = (num: number | string, maxNum: number) => {
  const no = Number(num)
  if (isNaN(no)) {
    return no
  }
  if (no <= maxNum) {
    return no
  }
  return `${maxNum}+`
}

/**
 * 特殊字符转义
 * @param str
 * @returns
 */
export const formatSpecialCharacter = (str: string) => {
  let res = str || ''
  const specialCharacter = [
    '\\',
    '$',
    '(',
    ')',
    '*',
    '+',
    '.',
    '[',
    '?',
    '^',
    '{',
    '|',
  ]
  specialCharacter.forEach((v) => {
    const reg = new RegExp('\\' + v, 'gim')
    res = res.replace(reg, '\\' + v)
  })
  return res
}

// 字符串标红格式化
const checkPara = (source: string, targetString: string) => {
  if (new RegExp(targetString, 'gi').test(source) && targetString !== '') {
    return true
  }
  return false
}
/**
 * 将源字符串的关键字标红
 * @param sourceString 源字符串
 * @param searchString 关键字字符串
 * @returns
 */
export const htmlToRed = (sourceString: string, searchString: string) => {
  searchString = formatSpecialCharacter(searchString)
  if (checkPara(sourceString, searchString)) {
    return sourceString.replace(
      new RegExp(searchString, 'gi'),
      '<span style=color:red>$&</span>',
    )
  } else return sourceString
}

// 供应商等级
export const enterpriseLevelList = [
  { name: '战略合作', value: '1', key: 'strategyFile' },
  { name: '一般合作', value: '2', key: 'commonlyFile' },
  { name: '项目合作', value: '3', key: 'projectFile' },
  { name: '零星合作', value: '4', key: 'sporadicFile' },
  { name: '电商类', value: '6', key: 'onlineFile' },
]

// 字符串每隔n位添加分隔符
export const formatSplitString = (str: string, gap: number, sep: string) => {
  if (!str) {
    return ''
  }
  const l = str.length - 1
  const strArr = str.split('') // 将字符串分割成字符串数组
  return strArr
    .map((elem, i) => {
      if (i % gap === gap - 1 && i !== l) {
        return elem + sep // 当前元素+分隔符
      } else {
        return elem
      }
    })
    .join('') // 放入一个字符串
}

export const getShipQty = (list: any[], strType: string) => {
  if (list?.length) {
    let num = 0
    list.forEach((item: any) => {
      num += item[strType]
    })
    return num
  }
  return 0
}

// 数字千分位格式化
export const numThousandsFormat = (n: any) => {
  const num = Number(n)
  if (isNaN(num)) {
    return n
  }
  const numArr = num.toString().split('.')
  // 整数部分
  let integerStr = numArr[0]
  // 小数部分
  const floatStr = numArr[1]
  const integerArr = integerStr.split('').reverse()
  integerStr = integerArr.reduce((prev, val, idx) => {
    if (idx % 3 === 0) {
      if (prev) {
        return val + ',' + prev
      } else {
        return val
      }
    } else {
      return val + prev
    }
  }, '')
  return floatStr ? `${integerStr}.${floatStr}` : integerStr
}

export const timeFormatStr = 'YYYY-MM-DD HH:mm:ss'

/**
 * 传入时间戳毫秒字符串,返回格式化好的时间
 * @param timestampStr
 * @returns
 */
export function formatTime(
  timestampStr: string | number,
  format: string = timeFormatStr,
) {
  if (typeof timestampStr === 'number') {
    return moment(timestampStr).format(format)
  } else if (typeof timestampStr === 'string') {
    const length = timestampStr?.length ?? 0
    if (length <= 10) {
      return '-'
    }
    const timestampNum = parseInt(timestampStr)
    return moment(timestampNum).format(format)
  } else {
    return '-'
  }
}

// 电商供应商订单-开票状态
export const invoicingState = [
  { name: '已开票', value: '1', color: '#52C41A' },
  { name: '未开票', value: '2', color: 'red' },
  { name: '开票中', value: '3', color: '#FFA940' },
] as const

// 发票类型
export const invoicingType = [
  { name: '电子发票(普通发票)', value: 'NORMAL', mapKey: '1' },
  { name: '电子发票(增值税专用发票)', value: 'INCREMENT_SPECIAL', mapKey: '2' },
]

// 判断一个数组的元素是否都相同
export const allElementsEqual = (arr: any[]) => {
  for (let i = 1; i < arr.length; i++) {
    if (arr[i] !== arr[0]) {
      return false
    }
  }
  return true
}

// 物料类型
export const materialType = materialTypeEnum.getKeyMappedList({
  label: 'name',
}) as { name: string; value: string }[]
export type MaterialType = MaterialTypeValue

// 自定义文件类型正则
export const generateRegExp = (str: string) => {
  // 将传入的字符串按照逗号分割成数组
  const arr = str.split(',')
  // 使用 Array.join() 方法将数组转化为正则表达式字符串
  const regStr = '^.*(' + arr.join('|') + ')$'
  // 创建 RegExp 对象并返回
  return new RegExp(regStr, 'i')
}

// 物料审核状态
export const materialAssessState = [
  // { name: '删除', value: '0' },
  { name: '正常', value: '1' },
  { name: '纠错审核申请中', value: '2' },
  { name: '纠错审核驳回', value: '3' },
  { name: '待纠错', value: '4' },
  { name: '新增审核中', value: '5' },
  { name: '新增失败', value: '6' },
  { name: '纠错审核中', value: '7' },
  { name: '纠错失败', value: '8' },
  { name: '撤回', value: '9' },
  { name: '缓存', value: '10' },
] as const

export const myLaunchState = [
  { name: '新增审核中', value: '5' },
  { name: '修改审核中', value: '11' },
  { name: '驳回', value: '22' },
  { name: '撤回', value: '9' },
  { name: '暂存', value: '10' },
  { name: '放弃（自动执行）', value: '23' },
]

export type myLaunchStateType = (typeof myLaunchState)[number]['value']

export type MaterialAssessType = (typeof materialAssessState)[number]['value']

export function getEnterpriseInfo(): Partial<EnterpriseInfo> {
  const enterpriseInfo = GetLocalStorage('HOME_DATA') || {}
  return enterpriseInfo
}
// 检测费
export const testingFeeList = [
  { key: '0', value: '不含检测费', title: '不含检测费' },
  { key: '1', value: '含第三方检测费', title: '含第三方检测费' },
  { key: '2', value: '含出厂检测费', title: '含出厂检测费' },
] as const

// 安装费
export const packingFeeList = [
  { key: '1', value: '含', title: '含安装费' },
  { key: '0', value: '不含', title: '不含安装费' },
] as const

export const getFeeText = (type: 'testingFee' | 'packingFee', key?: string) => {
  let target
  switch (type) {
    case 'packingFee':
      target = packingFeeList.find((item) => item.key === key)
      return target ? `【${target.title}】` : ''
    case 'testingFee':
      target = testingFeeList.find((item) => item.key === key)
      return target ? `【${target.title}】` : ''
  }
}

// 随机生成自定义长度的id
export const generateRandomId = (length = 8) => {
  let result = ''
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

/**
 * 新闻列表给的content字段含有html标签，需要移除掉
 * @param content
 * @returns
 */
export const removeTag = (content: string) => {
  const str = content.replace(/<.*?>/gi, '')
  return str.replace(/&nbsp;/gi, '')
}
// 物料链接取图校验
export const validatorExtractUrl = (rule: any, value: string) => {
  const val = value.trim()
  // 检查内容不为空
  if (!value || !val) {
    return Promise.reject('请填写平台链接地址')
  }

  const urlPattern = /^(https?|http?|ftp):\/\/[^\s/$.?#].[^\s]*$/i
  if (!urlPattern.test(val)) {
    return Promise.reject('暂不支持文本字符，请规范填写链接地址')
  }

  // 检查只允许上传一条链接地址
  if (
    (val.includes('http://') && val.includes('https://')) ||
    val.split('http://').length > 2 ||
    val.split('https://').length > 2
  ) {
    return Promise.reject('暂不支持多条地址链接，请检查后重试')
  }
  return Promise.resolve()
}

// 源单类型
export const orderTypeData = [
  {
    name: '供应商订单',
    code: '1',
    des: 'supplier',
    address:
      '线下寄票地址：收件人请填写您采购的联系方式，地址为浙江省海宁市长安镇启辉路16号咸亨创新产业园1幢7楼',
  },
  {
    name: '电商供应商订单',
    code: '2',
    des: 'lander',
    address:
      '线下寄票地址：王亚，17855973107，浙江省嘉兴市海宁市启辉路16号1号楼6楼财务室',
  },
] as const

const ASCII_REG = /[łŠőçÍÉÃŽØºñ]/

// 不能输入违禁词
export const checkASCII = (_: any, value: string) => {
  if (value && ASCII_REG.test(value)) {
    const arr = 'łŠőçÍÉÃŽØºñ'
    return Promise.reject(`无法输入系统禁止字符：${arr.split('').join('、')}`)
  }

  return Promise.resolve()
}

import {
  ConnectedProjectCode,
  PlatformField,
} from '@/modules/goodsdetailmodules/reducer'

// 合并平台列表（供应商物料：接口数据 + platformList 去重）
export const mergePlatformList = (
  connectedData: ConnectedProjectCode[],
  platforms: PlatformField[],
): PlatformField[] => {
  const connectedPlatforms: PlatformField[] = connectedData.map((item) => ({
    code: item.platformCode,
    name: item.platformName,
    pushRequirements: item.pushRequirements,
    itemFields: [], // 初始为空，选择时会重新获取
  }))
  const platformMap = new Map<string, PlatformField>()

  connectedPlatforms.forEach((item) => {
    platformMap.set(item.code, item)
  })

  platforms.forEach((item) => {
    if (!platformMap.has(item.code)) {
      platformMap.set(item.code, item)
    } else {
      const existing = platformMap.get(item.code)!
      if (!existing.pushRequirements && item.pushRequirements) {
        existing.pushRequirements = item.pushRequirements
      }
    }
  })

  return Array.from(platformMap.values())
}
import jwt_decode from 'jwt-decode'
import { tokenState } from '../modules/authtoken'
import { RcFile } from 'antd/lib/upload'
import { message } from 'antd'
import { LocalStorageKeyType } from './public'
import moment from 'moment'
import { EnterpriseInfo } from '../api/CommonApi'
import { SelectStorageKey } from '../global/fetchData'
import { filterApiData } from '../components/SearchFilter/TemplateData'
import { materialTypeEnum, MaterialTypeValue } from '../global/enum/product'
/**
 * 设置本地LocalStorage
 * @param key 唯一索引
 * @param data 数据
 */
export const SetLocalStorage = (key: LocalStorageKeyType, data: any) => {
  localStorage.setItem(key, JSON.stringify(data))
}

/**
 * 获取本地LocalStorage
 * @param key 唯一索引
 * @return: 数据|null
 */
export function GetLocalStorage(key: LocalStorageKeyType) {
  const data = localStorage.getItem(key)
  return data ? JSON.parse(data) : null
}

/**
 * 删除本地LocalStorage
 * @param key 唯一索引
 */
export const DelLocalStorage = (key: LocalStorageKeyType) => {
  localStorage.removeItem(key)
}

/**
 * 检查localStorage是否存在
 * @param key
 * @returns
 */
export const CheckLocalStorage = (key: LocalStorageKeyType) => {
  const item = localStorage.getItem(key)
  if (item !== null) {
    return true
  }
  return false
}

export function getStorageSelFn(key: SelectStorageKey) {
  const list = GetLocalStorage(key) ?? []
  return (page?: string, str?: string) => {
    return filterApiData(list, str, page)
  }
}

/**
 * 下载
 * @param param 路径
 */
export const download = (param: string, name?: string): void => {
  const a = document.createElement('a')
  a.setAttribute('href', param) // href链接
  a.setAttribute('download', name ? name : '') // download属性
  a.target = '_blank' // 360浏览器会覆盖原页面
  a.click() // 自执行点击事件
}

export const downloadFile = (
  url: string,
  fileName: string = 'file.pdf',
): void => {
  fetch(url)
    .then((res) => res.blob()) // 1. 将文件转为 Blob
    .then((blob) => {
      // 2. 创建一个临时的本地 URL (blob:http://...)
      const blobUrl = window.URL.createObjectURL(blob)

      const a = document.createElement('a')
      a.href = blobUrl
      a.download = fileName // 这里设置文件名在同源（blob）下是生效的
      a.style.display = 'none'

      document.body.appendChild(a)
      a.click()

      // 3. 清理：下载后移除元素并释放 URL 对象
      document.body.removeChild(a)
      window.URL.revokeObjectURL(blobUrl)
    })
    .catch((err) => {
      console.error('下载失败，可能是跨域CORS限制导致无法fetch文件:', err)
      // 如果 fetch 失败（例如严重的跨域限制），作为兜底可以用原逻辑打开
      window.open(url, '_blank')
    })
}
// 解析token
export const decodeAuthToken = (str: string) => {
  const data = jwt_decode<tokenState>(str)
  return data
}

// 重置对象数据
export const resetObj = (obj: { [x: string]: any }) => {
  for (const key in obj) {
    obj[key] = ''
  }
  return obj
}

// 指定上传文件格式
export const Accept = (type: 'image' | 'file' | 'custom') => {
  switch (type) {
    case 'image':
      return 'image/*'
    case 'file':
      return '.doc,.docx,.pdf,.xls,.xlsx,image/*'
    case 'custom':
      return '.jpeg,.gif,.jpg,.png'
    default:
      break
  }
}

// 从图片url中截取图片名称
export const getPicName = (val: string) => {
  const lastIndex = val.lastIndexOf('/')
  return val.substring(lastIndex + 1)
}

// 数字 数字+小数点 中英数字
type strType =
  | 'Number'
  | 'NumberDecimal'
  | 'Text'
  | 'other'
  | 'Format'
  | 'TextNumber'
  | 'English'
  | 'FilterSlash'
  | 'brandCnName'
  | 'brandEnName'
  | 'bankAccount'
  | 'trackingNumber'
export const formatStr = (str: string, type?: strType) => {
  // "[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]" 特殊字符
  if (type === 'Number') {
    // 只能输入数字
    // eslint-disable-next-line
    return str.replace(/[^0-9]/g, '')
  } else if (type === 'NumberDecimal') {
    // 只能数字、小数点
    // eslint-disable-next-line
    if (str[0] === '.') {
      return ''
    }
    return str.replace(/[^0-9.]/g, '').replace(/(\.\d*)\./g, '$1')
  } else if (type === 'Text') {
    // 只能输入中文、英文、数字
    // eslint-disable-next-line
    return str.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g, '')
  } else if (type === 'TextNumber') {
    // 只能输入英文、数字
    // eslint-disable-next-line
    return str.replace(/[^\a-\z\A-\Z0-9]/g, '')
  } else if (type === 'English') {
    // 只能输入英文
    // eslint-disable-next-line
    return str.replace(/[^\a-\z\A-\Z]/g, '')
  } else if (type === 'other') {
    // 替换英文'\ 空格
    // eslint-disable-next-line
    return str.replace(/[\"\\\s]/g, '')
  } else if (type === 'Format') {
    // 替换英文'\
    // eslint-disable-next-line
    return str.replace(/[\"\\]/g, '')
  } else if (type === 'FilterSlash') {
    // 替换英文'\ 空格 /
    // eslint-disable-next-line
    return str.replace(/[\"\\\/\s]/g, '')
    // 银行账户 只支持输入数字和-
  } else if (type === 'bankAccount') {
    // eslint-disable-next-line
    return str.replace(/[^0-9\-]/g, '')
    // 电商供应商发货单物流单号 支持输入英文数字，特殊字符只支持输入/ -
  } else if (type === 'trackingNumber') {
    // eslint-disable-next-line
    return str.replace(/[^a-zA-Z0-9\s/-]/g, '')
  }
  // 默认只能输入非空格的
  return str.replace(/\s+/g, '')
}

// 价格类格式化
export const formatterPrice = (val: any, number?: number) => {
  const value = String(val)
  const num = number ? number : 2
  if (!isNaN(Number(value)) && value.trim() !== '') {
    // 如果没有小数部分，补全为 .00
    if (
      !value.includes('.') ||
      value.split('.')[1].length === 1 ||
      value.endsWith('.')
    ) {
      return parseFloat(value).toFixed(num)
    } else if (value.split('.')[1].length >= num) {
      return parseFloat(value).toFixed(num)
    }
  }
}

// 编辑价格时，超出小数位返回当前内容，让用户自行判断
export const formatterEditPrice = (val: any, number?: number) => {
  const value = String(val)
  const num = number ? number : 2
  if (!isNaN(Number(value)) && value.trim() !== '') {
    // 如果没有小数部分，补全为 .00
    if (
      !value.includes('.') ||
      value.split('.')[1].length === 1 ||
      value.endsWith('.')
    ) {
      return parseFloat(value).toFixed(num)
    } else if (value.split('.')[1].length >= num) {
      return value // 超出小数位返回当前内容，让用户自行判断
    }
  }
}
export const checkImageWH = async (
  file: RcFile,
  width: number,
  height: number,
  errormessage: string,
) => {
  return new Promise(function (resolve, reject) {
    const filereader = new FileReader()
    filereader.onload = (e: any) => {
      const src = e.target ? e.target.result : ''
      const image = new Image()
      image.src = src
      image.onload = function () {
        if (image.naturalWidth !== width || image.naturalHeight !== height) {
          message.error(`上传失败:${errormessage}`)
          reject(false)
        } else {
          resolve(true)
        }
      }
      image.onerror = reject
    }
    filereader.readAsDataURL(file)
  })
}

// 物料等级
export const MaterialLevel = [
  { title: '主推', value: '1' },
  { title: '常规', value: '2' },
  { title: '零星', value: '3' },
]

// 部门属性
export const DepartmentAttr = [
  { title: '基本生产部门', value: 'DP01_SYS' },
  { title: '管理部门', value: 'DP02_SYS' },
  { title: '销售部门', value: 'DP03_SYS' },
  { title: '辅助生产部门', value: 'DP04_SYS' },
  { title: '采购部门', value: 'DP05_SYS' },
  { title: '研发部门', value: 'DP06_SYS' },
]

// 计息类型
export const InterestAttr = [
  { title: '代理品牌', value: 'JXLX0001' },
  { title: '自主品牌', value: 'JXLX0002' },
]

export type RoleTypeParam =
  | 'SOURCE_ASSESS_MAN'
  | 'SOURCE_ASSESS_MANAGER'
  | 'SOURCE_PURCHASE_MAN'
  | 'SOURCE_DATA_MAN'
  | 'SOURCE_PRODUCT_ASSISTANT'
  | 'root'

// 角色
export const RoleType = {
  SOURCE_ASSESS_MAN: 'SOURCE_ASSESS_MAN', // 审核员
  SOURCE_ASSESS_MANAGER: 'SOURCE_ASSESS_MANAGER', // 审核经理
  SOURCE_PURCHASE_MAN: 'SOURCE_PURCHASE_MAN', // 采购员
  SOURCE_PRODUCT_ASSISTANT: 'SOURCE_PRODUCT_ASSISTANT', // 商品助理
  SOURCE_DATA_MAN: 'SOURCE_DATA_MAN', // 数据管理员
}
/**
 * 产生随机整数，包含下限值，包括上限值
 * @param {Number} lower 下限
 * @param {Number} upper 上限
 * @return {Number} 返回在下限到上限之间的一个随机整数
 */
function random(lower: number, upper: number) {
  return Math.floor(Math.random() * (upper - lower + 1)) + lower
}
export const StatementText = () => {
  const arr = [
    '没人喜欢学习可这社会只要成绩',
    '不该有的感情要收起来 好好生活好好爱自己',
    '别在最好的年纪，辜负最好的自己',
    '努力一点吧 为了能走更好的路 遇见更优秀的人',
    '望自己成熟稳重善良填满优秀',
    '会有始料不及的运气会有突如其来的惊喜',
    '宇宙山河浪漫，生活点滴温暖，都值得我前进',
    '生活百般滋味 你要笑着面对',
    '努力过得充实 别留给自己难过的机会',
    '乾坤未定你 我皆是黑马',
    '你必须拼尽全力 才有资格说自己运气不好',
    '生活再平凡 也是限量版 别轻看自己',
    '只要你肯去努力 你就是幸运的',
    '你一定要努力与更好的人相遇',
    '一定要优秀 堵住那悠悠众口',
    '少点以为，多点作为',
    '这个世界从来不公平，你只有努力，才能换来那些平等的待遇',
    '心有猛虎 细嗅蔷薇',
    '你要优秀到所有人都不值得你委屈',
    '觉得已经晚了的时候 就是最早的时候',
  ]
  const index = random(0, arr.length - 1)
  return arr[index]
}

/**
 * 获取供应商id
 * @returns
 */
export const getSupplierId = () => {
  return GetLocalStorage('SUPPLIERID')
}

/**
 * 获取当前用户id
 * @returns
 */
export const getUserId = () => {
  return GetLocalStorage('USERID')
}

export const countToStr = (num: number, max = 99999): string => {
  if (num > max) {
    return max + '+'
  } else {
    return num + ''
  }
}

export const isResponseCodeSuccess = (responseCode: number): boolean => {
  if (responseCode === 0) {
    return true
  }
  return false
}
export const isResponseSuccess = (response: any): boolean => {
  const responseCode = response?.code
  return isResponseCodeSuccess(responseCode)
}

interface ItemInfo {
  id: string
  name: string
  code: string
}
type PlatformInfoKey = keyof ItemInfo

/**
 * srm订单模块  下单平台的列表
 */
export const getPlatformList = (): ItemInfo[] =>
  GetLocalStorage('PLATFORM') || []

export const getSupplierName = (): string =>
  GetLocalStorage('SUPPLIER_NAME') || []

// 中文转英文符号
export const convertToFullWidth = (str: string): string => {
  return str.replace(/[A-Za-z0-9!-/:-@[-`{-~]/g, (char) => {
    // 如果是字母或数字，直接将其转换为全角字符
    const code = char.charCodeAt(0)
    // 字符范围是从半角（33-126）到全角（65281-65374）
    return String.fromCharCode(code + 0xfee0)
  })
}

export const getPlatFormItem = (key: PlatformInfoKey, value: string) => {
  return getPlatformList().filter((item: ItemInfo) => {
    return item?.[key] === value
  })
}

/**
 * 根据下单平台的id 获取中文名
 * @param id
 * @returns
 */
export const getPlatformNameByid = (id: string) => {
  const reslist = getPlatFormItem('id', id)
  if (reslist) {
    return reslist[0].name
  }
  return ''
}

/**
 * 根据下单平台的中文名 获取id
 * @param name
 * @returns
 */
export const getPlatformIdbyName = (name: string) => {
  const reslist = getPlatFormItem('name', name)
  if (reslist) {
    return reslist[0]?.id
  }
  return ''
}
/**
 * 从对象列表中获取一个对象，用一个键值对从对象列表中定位对象
 * @param itemList
 * @param key
 * @param value
 * @returns
 */
export const getItemFromItemListByProperty = (
  itemList: any[],
  key: string,
  value: any,
) => {
  for (const item of itemList) {
    if (item[key] === value) {
      return item
    }
  }
  return undefined
}

// 防抖 typescript
export const debounce = (func: () => void, wait: number) => {
  let timer: any = null
  return function () {
    // 如果事件被触发的时候定时器不为空,重新设置定时器,这样就只有第一次的时候会执行,因为初始定时器为空,所以就会设置一个定时器,后续的点击会清空,导致最后请求被延迟执行
    if (timer) {
      clearTimeout(timer)
      timer = null
    }
    timer = setTimeout(func, wait)
  }
}

/**
 * 数字格式化：若超出最大数返回 最大数+ ，否则返回原数
 * @param num 原数
 * @param maxNum 最大数
 * @returns
 */
export const formatNum = (num: number | string, maxNum: number) => {
  const no = Number(num)
  if (isNaN(no)) {
    return no
  }
  if (no <= maxNum) {
    return no
  }
  return `${maxNum}+`
}

/**
 * 特殊字符转义
 * @param str
 * @returns
 */
export const formatSpecialCharacter = (str: string) => {
  let res = str || ''
  const specialCharacter = [
    '\\',
    '$',
    '(',
    ')',
    '*',
    '+',
    '.',
    '[',
    '?',
    '^',
    '{',
    '|',
  ]
  specialCharacter.forEach((v) => {
    const reg = new RegExp('\\' + v, 'gim')
    res = res.replace(reg, '\\' + v)
  })
  return res
}

// 字符串标红格式化
const checkPara = (source: string, targetString: string) => {
  if (new RegExp(targetString, 'gi').test(source) && targetString !== '') {
    return true
  }
  return false
}
/**
 * 将源字符串的关键字标红
 * @param sourceString 源字符串
 * @param searchString 关键字字符串
 * @returns
 */
export const htmlToRed = (sourceString: string, searchString: string) => {
  searchString = formatSpecialCharacter(searchString)
  if (checkPara(sourceString, searchString)) {
    return sourceString.replace(
      new RegExp(searchString, 'gi'),
      '<span style=color:red>$&</span>',
    )
  } else return sourceString
}

// 供应商等级
export const enterpriseLevelList = [
  { name: '战略合作', value: '1', key: 'strategyFile' },
  { name: '一般合作', value: '2', key: 'commonlyFile' },
  { name: '项目合作', value: '3', key: 'projectFile' },
  { name: '零星合作', value: '4', key: 'sporadicFile' },
  { name: '电商类', value: '6', key: 'onlineFile' },
]

// 字符串每隔n位添加分隔符
export const formatSplitString = (str: string, gap: number, sep: string) => {
  if (!str) {
    return ''
  }
  const l = str.length - 1
  const strArr = str.split('') // 将字符串分割成字符串数组
  return strArr
    .map((elem, i) => {
      if (i % gap === gap - 1 && i !== l) {
        return elem + sep // 当前元素+分隔符
      } else {
        return elem
      }
    })
    .join('') // 放入一个字符串
}

export const getShipQty = (list: any[], strType: string) => {
  if (list?.length) {
    let num = 0
    list.forEach((item: any) => {
      num += item[strType]
    })
    return num
  }
  return 0
}

// 数字千分位格式化
export const numThousandsFormat = (n: any) => {
  const num = Number(n)
  if (isNaN(num)) {
    return n
  }
  const numArr = num.toString().split('.')
  // 整数部分
  let integerStr = numArr[0]
  // 小数部分
  const floatStr = numArr[1]
  const integerArr = integerStr.split('').reverse()
  integerStr = integerArr.reduce((prev, val, idx) => {
    if (idx % 3 === 0) {
      if (prev) {
        return val + ',' + prev
      } else {
        return val
      }
    } else {
      return val + prev
    }
  }, '')
  return floatStr ? `${integerStr}.${floatStr}` : integerStr
}

export const timeFormatStr = 'YYYY-MM-DD HH:mm:ss'

/**
 * 传入时间戳毫秒字符串,返回格式化好的时间
 * @param timestampStr
 * @returns
 */
export function formatTime(
  timestampStr: string | number,
  format: string = timeFormatStr,
) {
  if (typeof timestampStr === 'number') {
    return moment(timestampStr).format(format)
  } else if (typeof timestampStr === 'string') {
    const length = timestampStr?.length ?? 0
    if (length <= 10) {
      return '-'
    }
    const timestampNum = parseInt(timestampStr)
    return moment(timestampNum).format(format)
  } else {
    return '-'
  }
}

// 电商供应商订单-开票状态
export const invoicingState = [
  { name: '已开票', value: '1', color: '#52C41A' },
  { name: '未开票', value: '2', color: 'red' },
  { name: '开票中', value: '3', color: '#FFA940' },
] as const

// 发票类型
export const invoicingType = [
  { name: '电子发票(普通发票)', value: 'NORMAL', mapKey: '1' },
  { name: '电子发票(增值税专用发票)', value: 'INCREMENT_SPECIAL', mapKey: '2' },
]

// 判断一个数组的元素是否都相同
export const allElementsEqual = (arr: any[]) => {
  for (let i = 1; i < arr.length; i++) {
    if (arr[i] !== arr[0]) {
      return false
    }
  }
  return true
}

// 物料类型
export const materialType = materialTypeEnum.getKeyMappedList({
  label: 'name',
}) as { name: string; value: string }[]
export type MaterialType = MaterialTypeValue

// 自定义文件类型正则
export const generateRegExp = (str: string) => {
  // 将传入的字符串按照逗号分割成数组
  const arr = str.split(',')
  // 使用 Array.join() 方法将数组转化为正则表达式字符串
  const regStr = '^.*(' + arr.join('|') + ')$'
  // 创建 RegExp 对象并返回
  return new RegExp(regStr, 'i')
}

// 物料审核状态
export const materialAssessState = [
  // { name: '删除', value: '0' },
  { name: '正常', value: '1' },
  { name: '纠错审核申请中', value: '2' },
  { name: '纠错审核驳回', value: '3' },
  { name: '待纠错', value: '4' },
  { name: '新增审核中', value: '5' },
  { name: '新增失败', value: '6' },
  { name: '纠错审核中', value: '7' },
  { name: '纠错失败', value: '8' },
  { name: '撤回', value: '9' },
  { name: '缓存', value: '10' },
] as const

export const myLaunchState = [
  { name: '新增审核中', value: '5' },
  { name: '修改审核中', value: '11' },
  { name: '驳回', value: '22' },
  { name: '撤回', value: '9' },
  { name: '暂存', value: '10' },
  { name: '放弃（自动执行）', value: '23' },
]

export type myLaunchStateType = (typeof myLaunchState)[number]['value']

export type MaterialAssessType = (typeof materialAssessState)[number]['value']

export function getEnterpriseInfo(): Partial<EnterpriseInfo> {
  const enterpriseInfo = GetLocalStorage('HOME_DATA') || {}
  return enterpriseInfo
}
// 检测费
export const testingFeeList = [
  { key: '0', value: '不含检测费', title: '不含检测费' },
  { key: '1', value: '含第三方检测费', title: '含第三方检测费' },
  { key: '2', value: '含出厂检测费', title: '含出厂检测费' },
] as const

// 安装费
export const packingFeeList = [
  { key: '1', value: '含', title: '含安装费' },
  { key: '0', value: '不含', title: '不含安装费' },
] as const

export const getFeeText = (type: 'testingFee' | 'packingFee', key?: string) => {
  let target
  switch (type) {
    case 'packingFee':
      target = packingFeeList.find((item) => item.key === key)
      return target ? `【${target.title}】` : ''
    case 'testingFee':
      target = testingFeeList.find((item) => item.key === key)
      return target ? `【${target.title}】` : ''
  }
}

// 随机生成自定义长度的id
export const generateRandomId = (length = 8) => {
  let result = ''
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

/**
 * 新闻列表给的content字段含有html标签，需要移除掉
 * @param content
 * @returns
 */
export const removeTag = (content: string) => {
  const str = content.replace(/<.*?>/gi, '')
  return str.replace(/&nbsp;/gi, '')
}
// 物料链接取图校验
export const validatorExtractUrl = (rule: any, value: string) => {
  const val = value.trim()
  // 检查内容不为空
  if (!value || !val) {
    return Promise.reject('请填写平台链接地址')
  }

  const urlPattern = /^(https?|http?|ftp):\/\/[^\s/$.?#].[^\s]*$/i
  if (!urlPattern.test(val)) {
    return Promise.reject('暂不支持文本字符，请规范填写链接地址')
  }

  // 检查只允许上传一条链接地址
  if (
    (val.includes('http://') && val.includes('https://')) ||
    val.split('http://').length > 2 ||
    val.split('https://').length > 2
  ) {
    return Promise.reject('暂不支持多条地址链接，请检查后重试')
  }
  return Promise.resolve()
}

// 源单类型
export const orderTypeData = [
  {
    name: '供应商订单',
    code: '1',
    des: 'supplier',
    address:
      '线下寄票地址：收件人请填写您采购的联系方式，地址为浙江省海宁市长安镇启辉路16号咸亨创新产业园1幢7楼',
  },
  {
    name: '电商供应商订单',
    code: '2',
    des: 'lander',
    address:
      '线下寄票地址：王亚，17855973107，浙江省嘉兴市海宁市启辉路16号1号楼6楼财务室',
  },
] as const

const ASCII_REG = /[łŠőçÍÉÃŽØºñ]/

// 不能输入违禁词
export const checkASCII = (_: any, value: string) => {
  if (value && ASCII_REG.test(value)) {
    const arr = 'łŠőçÍÉÃŽØºñ'
    return Promise.reject(`无法输入系统禁止字符：${arr.split('').join('、')}`)
  }

  return Promise.resolve()
}

import {
  ConnectedProjectCode,
  PlatformField,
} from '@/modules/goodsdetailmodules/reducer'

// 合并平台列表（供应商物料：接口数据 + platformList 去重）
export const mergePlatformList = (
  connectedData: ConnectedProjectCode[],
  platforms: PlatformField[],
): PlatformField[] => {
  const connectedPlatforms: PlatformField[] = connectedData.map((item) => ({
    code: item.platformCode,
    name: item.platformName,
    pushRequirements: item.pushRequirements,
    itemFields: [], // 初始为空，选择时会重新获取
  }))
  const platformMap = new Map<string, PlatformField>()

  connectedPlatforms.forEach((item) => {
    platformMap.set(item.code, item)
  })

  platforms.forEach((item) => {
    if (!platformMap.has(item.code)) {
      platformMap.set(item.code, item)
    } else {
      const existing = platformMap.get(item.code)!
      if (!existing.pushRequirements && item.pushRequirements) {
        existing.pushRequirements = item.pushRequirements
      }
    }
  })

  return Array.from(platformMap.values())
}
